import { seriesValueGetter } from './series-getter';
import { Series } from '../../../types/deal.types';

export function bqValueGetter(node: {
  data: { series: Series[]; isBankQualified: boolean };
}): string[] {
  const isBankQualifiedForSeries: string[] = seriesValueGetter(
    'isBankQualified'
  )(node).filter(bq => bq !== null);
  const isBankQualifiedForDeal: string = node.data.isBankQualified
    ? 'Yes'
    : 'No';
  return isBankQualifiedForSeries.length
    ? isBankQualifiedForSeries.map(bq => (bq ? 'Yes' : 'No'))
    : [isBankQualifiedForDeal];
}
